import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"

export function UserOrderRow({ order }) {
    const navigate = useNavigate()

    const [day, setDay] = useState(null)
    const [month, setMonth] = useState(null)
    const [year, setYear] = useState(null)

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

    useEffect(() => {
        const joinDateSplits = order.createdAt.split("-")

        setDay(joinDateSplits[2].slice(0, 2))
        setMonth(months[parseInt(joinDateSplits[1]) - 1])
        setYear(joinDateSplits[0])
    }, [])

    return (
        <table
            className="my-orders-table mt-2"
            onClick={() => navigate(`/account/orders/${order.orderId}`)}>
            <tbody>
                <tr className="">
                    <td className="">
                        <div className="d-flex cntr gap-3">
                            <div className={`order-image ${order.status.toLowerCase()}`}></div>
                            <div className="order-id">{order.orderId}</div>
                        </div>
                    </td>

                    <td className="">{month + " " + day + " " + year}</td>
                    <td className="">{order.products.length}</td>

                    <td className="status">
                        <div className="d-flex cntr gap-2">
                            <div className={
                                `rounded-circle p-2 ${order.status.toLowerCase() === "pending" ?
                                "pending" : order.status.toLowerCase() === "delivered" ?
                                "delivered" : "primary"
                                }`}></div>
                            <div>{order.status}</div>
                        </div>
                    </td>

                    <td className="text-center pe-3">${order.totalAmount}</td>
                </tr>
            </tbody>
        </table>
    )
}